module.exports = PTP_FE_COMMON;